export const useTrackingEvents = () => {
	const eventNameMap = {
		fbq: {
			add_to_cart: 'AddToCart',
			initiate_checkout: 'InitiateCheckout',
			checkout: 'Purchase',
			lead: 'Lead',
			page_visit: 'ViewContent',
			search: 'Search',
			intent_login: 'Lead',
			intent_signup: 'Lead',
			signup_complete: 'CompleteRegistration',
			login_success: 'Lead',
		},
		pinterest: {
			add_to_cart: 'add_to_cart',
			initiate_checkout: 'initiate_checkout',
			checkout: 'checkout',
			lead: 'lead',
			page_visit: 'page_visit',
			search: 'search',
			intent_login: 'lead',
			intent_signup: 'lead',
			signup_complete: 'signup',
			login_success: 'login',
		},
		gtm: {
			add_to_cart: 'add_to_cart',
			initiate_checkout: 'initiate_checkout',
			checkout: 'checkout',
			lead: 'lead',
			page_visit: 'page_visit', // use for product viewed
			search: 'search',
			intent_login: 'intent_login',
			intent_signup: 'intent_signup',
			signup_complete: 'signup_complete',
			login_success: 'login_success',
		},
	};

	const epik = document.cookie
		.split('; ')
		.find(row => row.startsWith('_epik='))
		?.split('=')[1];

	const sendTrackingEvent = (internalEventName, eventData) => {
		const fbqName = eventNameMap.fbq[internalEventName];
		const pinterestName = eventNameMap.pinterest[internalEventName];
		const gtmName = eventNameMap.gtm[internalEventName];

		// Facebook Pixel
		if (window.fbq && fbqName) {
			window.fbq('track', fbqName, {
				...eventData,
			});
		}

		// Google Tag Manager
		if (window.dataLayer && gtmName) {
			window.dataLayer.push({
				event: gtmName,
				...eventData,
			});
		}

		// Pinterest
		if (window.pintrk && pinterestName) {
			window.pintrk('track', pinterestName, {
				...eventData,
				...(epik && { click_id: epik }),
			});
		}

		// Optional: Logging
		// console.log(`[Tracking] ${internalEventName}`, eventData);
	};

	return { sendTrackingEvent };
};
